var React = require('react');

function Key (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.5707 15.5242C13.7541 15.5242 15.5242 13.7541 15.5242 11.5707C15.5242 9.38722 13.7541 7.61719 11.5707 7.61719C9.38723 7.61719 7.61719 9.38722 7.61719 11.5707C7.61719 13.7541 9.38723 15.5242 11.5707 15.5242Z","stroke":"#D22128","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M21.7822 9.35096H40.8943V13.7696H36.7294V18.1036H32.5645V13.9176H21.7822H21.7611C20.6829 18.5687 16.518 22.0148 11.5708 22.0148C5.77802 22.0148 1.10571 17.3425 1.10571 11.5708C1.10571 5.79916 5.77802 1.10571 11.5708 1.10571C16.5814 1.10571 20.7674 4.63637 21.7822 9.35096Z","stroke":"#D22128","strokeMiterlimit":"10","key":1})]);
}

Key.defaultProps = {"width":"42","height":"23","viewBox":"0 0 42 23","fill":"none"};

module.exports = Key;

Key.default = Key;
